import React from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

interface DurationFormatterProps {
  durationInMs?: number | undefined;
  fromDate?: Date | undefined;
  withSuffix?: boolean;
}

dayjs.extend(duration);

const formatDuration = (millis: number, withSuffix: boolean = false) => {
  return withSuffix ? dayjs.duration(millis).format('H[h] m[m] s[s]') : dayjs.duration(millis).format('HH:mm:ss');
};

const FormattedDuration = ({ durationInMs, withSuffix = false }: DurationFormatterProps) => {
  if (durationInMs) {
    return <span>{formatDuration(durationInMs, withSuffix)}</span>;
  } else {
    return <span>-</span>;
  }
};

export default FormattedDuration;
